export const tableHeaderReceivedEmailHistoryTable = [
  {
    headerStyles: 'w-[9%]',
    rowStyles: 'w-[9%] py-5 break-all pl-2 align-top',
    name: 'PG Number',
    label: 'application_number',
    isFilter: true,
    isFilterDate: false,
    isOneLineRes: false,
  },
  {
    headerStyles: 'w-[13%]',
    rowStyles: 'w-[13%] py-5 break-all pl-2 align-top',
    name: 'Received At', // Only show the name
    label: 'created_at', // Date store in database
    isFilter: false,
    isFilterDate: false,
    isOneLineRes: false,
  },
  {
    headerStyles: 'w-[15%]',
    rowStyles: 'w-[15%] py-5 break-all pl-2 align-top',
    name: 'Receiver',
    label: 'receiver',
    isFilter: true,
    isFilterDate: true,
    isOneLineRes: false,
  },
  {
    headerStyles: 'w-[16%]',
    rowStyles: 'w-[16%] py-5 break-all pl-2 align-top',
    name: 'Subject',
    label: 'subject',
    isFilter: true,
    isFilterDate: true,
    isOneLineRes: false,
  },
  {
    headerStyles: 'w-[23%]',
    rowStyles: 'w-[23%] py-5 break-all pl-2 align-top',
    name: 'Content',
    label: 'content',
    isFilter: true,
    isFilterDate: false,
    isOneLineRes: false,
  },
  {
    headerStyles: 'w-[14%] ',
    rowStyles: 'w-[14%] py-5 break-all pl-2 align-top',
    name: 'Bond Number',
    label: 'carrier_bond_number',
    isFilter: true,
    isFilterDate: true,
    isOneLineRes: false,
  },
  {
    headerStyles: 'w-[8%]',
    rowStyles: 'w-[8%] py-5 break-all pl-2 align-top',
    name: 'Is Processed',
    label: 'is_processed',
    isFilter: false,
    isFilterDate: false,
    isOneLineRes: false,
  },
  {
    headerStyles: 'w-[2%]',
    rowStyles: 'w-[2%] py-5 align-top',
    name: '',
    label: 'action',
    isFilter: false,
    isFilterDate: false,
    isOneLineRes: false,
  },
]
